import React from "react";
import { Grid, Card, CardContent } from "@mui/material";
import "./Grid.style.css";
import KeyOption from "../../interfaces/KeyOption.interface";
import useQuestion from "../../hooks/useQuestion";

type CustomCardProps = {
  category: string;
  image: string;
  value: string;
  callback: (value: string) => void;
};

const CustomCard: React.FC<CustomCardProps> = React.memo(
  ({ category, image, value, callback }) => (
    <Card
      onClick={() => {
        callback(value);
      }}
      className="grid-card"
      data-testid={`custom-card-${value}`}
    >
      <CardContent className="grid-card-content">
        <img
          alt="category"
          src={process.env.PUBLIC_URL + image}
          className={`image ${category}`}
        />
      </CardContent>
    </Card>
  )
);

const ResponsiveGrid: React.FC = React.memo(() => {
  const { options, handleSelect } = useQuestion();

  return (
    <React.Fragment>
      <div className="container-with-scroll">
        <Grid container spacing={2}>
          {options?.map((option: KeyOption) => (
            <Grid item padding={"5px"} xs={6} sm={4} md={3} key={option.id}>
              <CustomCard
                value={option.value}
                callback={handleSelect}
                category={option.category}
                image={option.image}
              />
            </Grid>
          ))}
        </Grid>
      </div>
    </React.Fragment>
  );
});

export default ResponsiveGrid;
